import { render, staticRenderFns } from "./index原版.vue?vue&type=template&id=511b9160&scoped=true&"
import script from "./index原版.vue?vue&type=script&lang=js&"
export * from "./index原版.vue?vue&type=script&lang=js&"
import style0 from "./index原版.vue?vue&type=style&index=0&id=511b9160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b9160",
  null
  
)

export default component.exports